function getCartItem(state, productId, saleDateId) {
    return saleDateId
        ? state.shop_cart_items.find(item => item.product_id === productId && item.sale_date_id === saleDateId)
        : state.shop_cart_items.find(item => item.product_id === productId && item.sale_date_id === null);
}

function removeCartItem(state, shopCartItem) {

    if (shopCartItem.product.product_card) {
        if (!window.dataLayer) {
            window.dataLayer = [];
        }
        window.dataLayer.push({
            ecommerce: {
                currencyCode: 'RUB',
                remove: {
                    products: [{
                        id: shopCartItem.product.id,
                        name: shopCartItem.product.product_card.title,
                        quantity: shopCartItem.quantity,
                    }]
                }
            }
        });
    }

    state.shop_cart_items = shopCartItem.sale_date
        ? state.shop_cart_items.filter(item => !(item.product_id === shopCartItem.product_id && item.sale_date_id === shopCartItem.sale_date_id))
        : state.shop_cart_items.filter(item => !(item.product_id === shopCartItem.product_id && item.sale_date_id === null));
}

export default {
    state: () => ({
        shop_cart_items: [],
        legal: null,
        storefront: null,
        nearest_execution_date: null,
    }),
    mutations: {
        initShopCart(state, response) {
            const payload = response ?? {};
            const shops = Array.isArray(payload.shops) ? payload.shops : [];
            const items = Array.isArray(payload.shop_cart_items) ? payload.shop_cart_items : [];
            state.shop_cart_items = [];
            state.legal = payload.legal ?? null;
            state.storefront = payload.storefront ?? null;
            state.nearest_execution_date = payload.nearest_execution_date ?? null;
            items.forEach(function (shopCartItem) {
                let product = shopCartItem.product;
                product.shop = shops.find(s => s.id === product.shop_id);
                state.shop_cart_items.push({
                    id: shopCartItem.id,
                    product_id: shopCartItem.product_id,
                    sale_date_id: shopCartItem.sale_date_id,
                    quantity: shopCartItem.quantity,
                    execution_date: shopCartItem.execution_date,
                    execution_date_selected: shopCartItem.execution_date_selected,
                    product: product,
                    sale_date: shopCartItem.sale_date,
                    discount: shopCartItem.discount
                        ? {
                            discount_value: shopCartItem.discount.discount_value,
                            original_price: shopCartItem.discount.original_price,
                            price_with_discount: shopCartItem.discount.price_with_discount,
                            model: shopCartItem.discount.model,
                        }
                        : null,
                });
            });
        },
        saveCartItem(state, shopCartItem) {
            let existingItem = getCartItem(state, shopCartItem.product_id, shopCartItem.sale_date_id);
            if (existingItem) {
                existingItem.product_id = shopCartItem.product_id;
                existingItem.sale_date_id = shopCartItem.sale_date ? shopCartItem.sale_date.id : null;
                existingItem.quantity = shopCartItem.quantity;
                existingItem.discount = shopCartItem.discount
                    ? {
                        discount_value: shopCartItem.discount.discount_value,
                        original_price: shopCartItem.discount.original_price,
                        price_with_discount: shopCartItem.discount.price_with_discount,
                        model: shopCartItem.discount.model,
                    }
                    : null;
            } else {
                state.shop_cart_items.push({
                    id: shopCartItem.id,
                    product_id: shopCartItem.product.id,
                    sale_date_id: shopCartItem.sale_date ? shopCartItem.sale_date.id : null,
                    quantity: shopCartItem.quantity,
                    product: shopCartItem.product,
                    sale_date: shopCartItem.sale_date,
                    discount: shopCartItem.discount
                        ? {
                            discount_value: shopCartItem.discount.discount_value,
                            original_price: shopCartItem.discount.original_price,
                            price_with_discount: shopCartItem.discount.price_with_discount,
                            model: shopCartItem.discount.model,
                        }
                        : null,
                });

                if (shopCartItem.product.product_card) {
                    if (!window.dataLayer) {
                        window.dataLayer = [];
                    }
                    window.dataLayer.push({
                        ecommerce: {
                            currencyCode: 'RUB',
                            add: {
                                products: [{
                                    id: shopCartItem.product.id,
                                    name: shopCartItem.product.product_card.title,
                                    price: shopCartItem.sale_date ? shopCartItem.sale_date.price : 0,
                                    quantity: shopCartItem.quantity,
                                }]
                            }
                        }
                    });
                }

            }
        },
        removeCartItem(state, shopCartItem) {
            removeCartItem(state, shopCartItem);
        },
    },
    actions: {
        initShopCart({ commit }, response) {
            commit('initShopCart', response);
        },
        saveCartItem({ commit }, shopCartItem) {
            commit('saveCartItem', shopCartItem);
        },
        removeCartItem({ commit }, shopCartItem) {
            commit('removeCartItem', shopCartItem);
        },
    },
    getters: {
        getShopCartItems(state) {
            return state.shop_cart_items;
        },
        getShopCartItem: (state) => (productId, saleDateId) => {
            return getCartItem(state, productId, saleDateId);
        },
        getShopCartLegal(state) {
            return state.legal;
        },
        getNearestExecutionDate(state) {
            return state.nearest_execution_date;
        },
        getShopCartStorefront(state) {
            return state.storefront;
        },
    },
};
